export function isNotNullOrUndefined(value) {
  return value !== null && value !== undefined;
}

export default isNotNullOrUndefined;
